"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HyperModelSchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
exports.HyperModelSchema = yup_lib_1.default.object().shape({
    _id: yup_lib_1.default.string().required(),
    hyper_document_type: yup_lib_1.default.string().required()
});
